import React from 'react'

import { PopoverContext } from '../../provider'

export function ContextualCardTarget({ children }: React.PropsWithChildren) {
  const { openPopover } = React.useContext(PopoverContext)

  return <span onClick={() => openPopover()}>{children}</span>
}

ContextualCardTarget.displayName = 'ContextualCard.Target'
